/* eslint-disable */
import axios from '../index'

const getAll = () => {
  return axios.get('careers')
}
const getVacancyById = (id) => {
  return axios.get(`careers/${id}`)
}

const api = { getAll, getVacancyById }


export default api;